(function () {
  function toDayCount(value) {
    var dayCount = Number.parseInt(value, 10)

    return Number.isFinite(dayCount) && dayCount > 0 ? dayCount : 0
  }

  function addBusinessDays(startDate, dayCount) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 12)
    var remainingDays = dayCount

    while (remainingDays > 0) {
      date.setDate(date.getDate() + 1)

      if (date.getDay() !== 0 && date.getDay() !== 6) {
        remainingDays -= 1
      }
    }

    return date
  }

  function formatDeliveryDateRange(earliestDate, latestDate) {
    var sameMonth = earliestDate.getFullYear() === latestDate.getFullYear() &&
      earliestDate.getMonth() === latestDate.getMonth()
    var earliestFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: earliestDate.getFullYear() === latestDate.getFullYear() ? undefined : 'numeric'
    })
    var latestFormatter = new Intl.DateTimeFormat('en-US', sameMonth ? {
      day: 'numeric'
    } : {
      month: 'short',
      day: 'numeric',
      year: earliestDate.getFullYear() === latestDate.getFullYear() ? undefined : 'numeric'
    })

    return earliestFormatter.format(earliestDate) + ' – ' + latestFormatter.format(latestDate)
  }

  function formatDeliveryDate(date) {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(date)
  }

  function formatLocalDateValue(date) {
    var month = String(date.getMonth() + 1).padStart(2, '0')
    var day = String(date.getDate()).padStart(2, '0')

    return date.getFullYear() + '-' + month + '-' + day
  }

  function getDeliverySchedule(dateRange) {
    var processingDays = toDayCount(dateRange.dataset.processingDays)
    var shippingMinDays = toDayCount(dateRange.dataset.shippingMinDays)
    var shippingMaxDays = Math.max(shippingMinDays, toDayCount(dateRange.dataset.shippingMaxDays))
    var today = new Date()

    return {
      today: today,
      shipDate: addBusinessDays(today, processingDays),
      earliestDate: addBusinessDays(today, processingDays + shippingMinDays),
      latestDate: addBusinessDays(today, processingDays + shippingMaxDays)
    }
  }

  function updateDeliveryDateRange(block) {
    var dateRange = block.querySelector('[data-cu-delivery-date-range]')

    if (!dateRange || typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
      return
    }

    var schedule = getDeliverySchedule(dateRange)
    var timelinePrompt = dateRange.hasAttribute('data-cu-delivery-timeline-toggle')
      ? '. Show order timeline.'
      : ''
    var accessibleFormatter = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })

    dateRange.textContent = formatDeliveryDateRange(schedule.earliestDate, schedule.latestDate)
    dateRange.setAttribute(
      'aria-label',
      'Estimated delivery between ' + accessibleFormatter.format(schedule.earliestDate) +
        ' and ' + accessibleFormatter.format(schedule.latestDate) + timelinePrompt
    )
  }

  function updateDeliveryTimeline(block) {
    var dateRange = block.querySelector('[data-cu-delivery-date-range]')
    var orderDate = block.querySelector('[data-cu-delivery-order-date]')
    var shipDate = block.querySelector('[data-cu-delivery-ship-date]')
    var deliveryRange = block.querySelector('[data-cu-delivery-timeline-range]')

    if (
      !dateRange ||
      !orderDate ||
      !shipDate ||
      !deliveryRange ||
      typeof Intl === 'undefined' ||
      typeof Intl.DateTimeFormat !== 'function'
    ) {
      return
    }

    var schedule = getDeliverySchedule(dateRange)

    orderDate.textContent = formatDeliveryDate(schedule.today)
    orderDate.setAttribute('datetime', formatLocalDateValue(schedule.today))
    shipDate.textContent = formatDeliveryDate(schedule.shipDate)
    shipDate.setAttribute('datetime', formatLocalDateValue(schedule.shipDate))
    deliveryRange.textContent = formatDeliveryDateRange(schedule.earliestDate, schedule.latestDate)
    deliveryRange.setAttribute(
      'aria-label',
      'Delivered between ' + formatDeliveryDate(schedule.earliestDate) +
        ' and ' + formatDeliveryDate(schedule.latestDate)
    )
  }

  function initializeDeliveryBlocks(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-delivery-block]').forEach(function (block) {
      if (block.dataset.cuDeliveryReady === 'true') {
        return
      }

      updateDeliveryDateRange(block)
      updateDeliveryTimeline(block)

      var timelineToggle = block.querySelector('[data-cu-delivery-timeline-toggle]')
      var timeline = block.querySelector('[data-cu-delivery-timeline]')

      if (timelineToggle && timeline) {
        function setTimelineOpen(isOpen) {
          timeline.hidden = !isOpen
          timelineToggle.setAttribute('aria-expanded', String(isOpen))
          block.classList.toggle('is-timeline-open', isOpen)
        }

        timelineToggle.addEventListener('click', function () {
          setTimelineOpen(timeline.hidden)
        })

        block._cuDeliveryTimelineDocumentClick = function (event) {
          if (!timeline.hidden && !timelineToggle.contains(event.target) && !timeline.contains(event.target)) {
            setTimelineOpen(false)
          }
        }

        block._cuDeliveryTimelineDocumentKeydown = function (event) {
          if (event.key === 'Escape' && !timeline.hidden) {
            setTimelineOpen(false)
            timelineToggle.focus()
          }
        }

        document.addEventListener('click', block._cuDeliveryTimelineDocumentClick)
        document.addEventListener('keydown', block._cuDeliveryTimelineDocumentKeydown)
      }

      var trigger = block.querySelector('[data-cu-delivery-open]')
      var modal = block.querySelector('[data-cu-delivery-modal]')
      var dialog = block.querySelector('[data-cu-delivery-dialog]')
      var form = block.querySelector('[data-cu-delivery-form]')
      var countrySelect = block.querySelector('[data-cu-delivery-country]')
      var currencySelect = block.querySelector('[data-cu-delivery-currency]')
      var status = block.querySelector('[data-cu-delivery-status]')

      if (!trigger || !modal || !dialog || !form || !countrySelect || !currencySelect) {
        return
      }

      block.dataset.cuDeliveryReady = 'true'
      var lastFocusedElement = null

      function getBucksCurrency() {
        var styledValue = document.querySelector('.bucks-selected')
        var nativeSelector = document.querySelector('#bucksSelector')
        var currentCurrency = styledValue && styledValue.textContent.trim()

        if (!currentCurrency && nativeSelector) {
          currentCurrency = nativeSelector.value
        }

        return /^[A-Z]{3}$/.test(currentCurrency || '') ? currentCurrency : ''
      }

      function getBucksCurrencies() {
        var currencies = []

        document.querySelectorAll('#bucksSelector option, .buckscc-select-options .converterTriggers').forEach(function (option) {
          var currency = (option.value || option.id || '').trim().toUpperCase()

          if (/^[A-Z]{3}$/.test(currency) && currencies.indexOf(currency) === -1) {
            currencies.push(currency)
          }
        })

        var currentCurrency = getBucksCurrency()

        if (currentCurrency && currencies.indexOf(currentCurrency) === -1) {
          currencies.unshift(currentCurrency)
        }

        return currencies
      }

      function refreshCurrenciesFromBucks() {
        var currencies = getBucksCurrencies()

        if (!currencies.length) {
          return false
        }

        var existingCurrencies = Array.prototype.map.call(currencySelect.options, function (option) {
          return option.value
        })

        if (existingCurrencies.join('|') !== currencies.join('|')) {
          currencySelect.textContent = ''

          currencies.forEach(function (currency) {
            var option = document.createElement('option')

            option.value = currency
            option.textContent = currency
            currencySelect.appendChild(option)
          })
        }

        var currentCurrency = getBucksCurrency()

        if (currentCurrency && currencies.indexOf(currentCurrency) !== -1) {
          currencySelect.value = currentCurrency
        }

        return true
      }

      function selectBucksCurrency(currency) {
        if (!currency || currency === getBucksCurrency()) {
          return true
        }

        var currencyTrigger = Array.prototype.find.call(
          document.querySelectorAll('.buckscc-select-options .converterTriggers'),
          function (option) {
            return option.id === currency
          }
        )

        if (!currencyTrigger) {
          return false
        }

        currencyTrigger.click()
        return getBucksCurrency() === currency
      }

      function syncCurrencyFromCountry() {
        if (getBucksCurrencies().length) {
          return
        }

        var selectedCountry = countrySelect.options[countrySelect.selectedIndex]

        if (selectedCountry && selectedCountry.dataset.currency) {
          currencySelect.value = selectedCountry.dataset.currency
        }
      }

      function syncCountryFromCurrency() {
        if (getBucksCurrencies().length) {
          return
        }

        var selectedCurrency = currencySelect.value
        var matchingCountry = Array.prototype.find.call(countrySelect.options, function (option) {
          return option.dataset.currency === selectedCurrency
        })

        if (matchingCountry) {
          countrySelect.value = matchingCountry.value
        }
      }

      function openModal() {
        lastFocusedElement = document.activeElement
        refreshCurrenciesFromBucks()

        if (status) {
          status.textContent = ''
        }

        modal.hidden = false
        trigger.setAttribute('aria-expanded', 'true')
        document.documentElement.classList.add('cu-delivery-modal-open')
        countrySelect.focus()
      }

      function closeModal(restoreFocus) {
        modal.hidden = true
        trigger.setAttribute('aria-expanded', 'false')

        if (!document.querySelector('[data-cu-delivery-modal]:not([hidden])')) {
          document.documentElement.classList.remove('cu-delivery-modal-open')
        }

        if (restoreFocus && lastFocusedElement) {
          lastFocusedElement.focus()
        }
      }

      trigger.addEventListener('click', openModal)

      modal.querySelectorAll('[data-cu-delivery-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          closeModal(true)
        })
      })

      countrySelect.addEventListener('change', syncCurrencyFromCountry)
      currencySelect.addEventListener('change', syncCountryFromCurrency)

      form.addEventListener('submit', function (event) {
        if (getBucksCurrencies().length && !selectBucksCurrency(currencySelect.value)) {
          event.preventDefault()

          if (status) {
            status.textContent = 'The currency selector is still loading. Please try again.'
          }
        }
      })

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault()
          closeModal(true)
          return
        }

        if (event.key !== 'Tab') {
          return
        }

        var focusable = dialog.querySelectorAll('button:not([disabled]), select:not([disabled])')
        var firstFocusable = focusable[0]
        var lastFocusable = focusable[focusable.length - 1]

        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault()
          lastFocusable.focus()
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault()
          firstFocusable.focus()
        }
      })

      syncCurrencyFromCountry()
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeDeliveryBlocks(document)
    })
  } else {
    initializeDeliveryBlocks(document)
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeDeliveryBlocks(event.target)
  })

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-cu-delivery-block]').forEach(function (block) {
      if (block._cuDeliveryTimelineDocumentClick) {
        document.removeEventListener('click', block._cuDeliveryTimelineDocumentClick)
      }

      if (block._cuDeliveryTimelineDocumentKeydown) {
        document.removeEventListener('keydown', block._cuDeliveryTimelineDocumentKeydown)
      }
    })

    if (event.target.querySelector('[data-cu-delivery-modal]:not([hidden])')) {
      document.documentElement.classList.remove('cu-delivery-modal-open')
    }
  })
})()
